import { HeartHandshake } from "lucide-react";
import { HOME } from "@/constants/testIds";

export default function MentalHealthAccountability() {
  return (
    <section data-testid={HOME.mentalHealthSection} className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
      <div className="bg-zinc-950 text-white rounded-sm p-10 md:p-14">
        <HeartHandshake className="h-9 w-9 text-[#4FD1C5] mb-5" />
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#4FD1C5] mb-3">Mental Health & Accountability</p>
        <h2 className="font-display font-extrabold uppercase text-2xl md:text-3xl tracking-tight mb-5">
          Bias leaves a real toll. We're building real support.
        </h2>
        <p className="text-zinc-300 leading-relaxed max-w-3xl mb-4">
          Living with continuous, systemic bias — especially when racial bias becomes systemic and oppressive
          — carries a genuine mental health cost. It wears people down over time, even when no single moment
          seems severe enough to name on its own.
        </p>
        <p className="text-zinc-300 leading-relaxed max-w-3xl">
          BBAP isn't just building a tracking tool. We're building systems to recognize that toll and connect
          people who've experienced it to real mental health solutions and support pathways. Documentation is
          step one — care and accountability are the point.
        </p>
      </div>
    </section>
  );
}
